import {Button} from '@features/ui/components/Button';
import {Modal} from '@nextui-org/react';
import {ModalContent} from '@nextui-org/react';
import {LoaderCircle} from 'lucide-react';

export const DeletionModal = ({
  onDelete,
  isOpen,
  onClose,
  title,
  body,
  isLoading = false,
  loadingText = 'Deleting...',
  buttonText = 'Delete',
  deleteDisabled = false,
}: {
  onDelete: () => Promise<void>;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body: string;
  isLoading?: boolean;
  loadingText?: string;
  buttonText?: string;
  deleteDisabled?: boolean;
}) => (
  <Modal
    backdrop='opaque'
    isOpen={isOpen}
    onClose={onClose}
    className='w-[280px] bg-white text-black'
    hideCloseButton
  >
    <ModalContent className='rounded-[18px] p-4'>
      {(onClose) => (
        <>
          <div className='mb-1 text-sm font-semibold'>{title}</div>
          <div className='mb-4 text-sm font-normal'>{body}</div>
          <div className='flex flex-col gap-[8px]'>
            {!deleteDisabled && (
              <Button
                onClick={() => void onDelete()}
                className='flex items-center justify-center gap-2 bg-[#FF3366] text-white'
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <LoaderCircle className='size-4 animate-spin' />
                    {loadingText}
                  </>
                ) : (
                  buttonText
                )}
              </Button>
            )}
            <Button
              onClick={onClose}
              className='bg-muted text-black'
              disabled={isLoading}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </ModalContent>
  </Modal>
);
